import React, { useState, useEffect } from 'react';
import { checkIPAccess, isIPAccessEnabled } from '../services/ipService';

const AccessGate = ({ children }) => {
  const [accessStatus, setAccessStatus] = useState({
    loading: true,
    approved: false,
    ip: '',
    reason: ''
  });

  useEffect(() => {
    const checkAccess = async () => {
      // If IP access control is disabled, allow access
      if (!isIPAccessEnabled()) {
        setAccessStatus({
          loading: false,
          approved: true,
          ip: 'Disabled',
          reason: 'IP access control is disabled'
        });
        return;
      }

      try {
        const result = await checkIPAccess();
        setAccessStatus({
          loading: false,
          approved: result.approved,
          ip: result.ip,
          reason: result.reason
        });
      } catch (error) {
        console.error('Error checking access:', error);
        setAccessStatus({
          loading: false,
          approved: false,
          ip: 'Error',
          reason: 'Failed to check access'
        });
      }
    };

    checkAccess();
  }, []);

  if (accessStatus.loading) {
    return (
      <div className="access-gate-loading">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Checking access permissions...</p>
        </div>
      </div>
    );
  }

  if (!accessStatus.approved) {
    return (
      <div className="access-gate-denied">
        <div className="access-denied-container">
          <div className="access-denied-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.9 1 3 1.9 3 3V21C3 22.1 3.9 23 5 23H19C20.1 23 21 22.1 21 21V9ZM19 9H14V4H5V21H19V9Z" fill="#dc3545"/>
            </svg>
          </div>
          <h1>Access Restricted</h1>
          <div className="access-denied-message">
            <p>This is a <strong>Strand Products internal tool</strong> and can only be accessed when in a certain location.</p>
            <p>Your current IP address: <code>{accessStatus.ip}</code></p>
            <p className="access-reason">Reason: {accessStatus.reason}</p>
          </div>
          <div className="access-denied-contact">
            <p>If you believe you should have access to this application, please contact your system administrator.</p>
          </div>
        </div>
      </div>
    );
  }

  // If access is approved, render the children
  return children;
};

export default AccessGate;
